module.exports = __webpack_public_path__ + "static/img/level-7-2.18eb74b1.png";